// Translations
import landing from '../views/landing/translations/en'

// Translation: Verification (English)
export default Object.freeze({
	name: 'Verification',
	views: { landing }
})
